export const locations = [
  {
    display: 'Austin, TX',
    value: 'atx',
  },
  {
    display: 'Birmingham, AL',
    value: 'bhm',
  },
  {
    display: 'Boca Raton, FL',
    value: 'boc',
  },
  {
    display: 'Charleston, SC',
    value: 'chs',
  },
  {
    display: 'Charlotte, NC',
    value: 'clt',
  },
  {
    display: 'Cleveland, OH',
    value: 'cle',
  },
  {
    display: 'Columbus, OH',
    value: 'coh',
  },
  {
    display: 'Dallas, TX',
    value: 'dfw',
  },
  {
    display: 'Frisco, TX',
    value: 'ftx',
  },
  {
    display: 'Greenville, SC',
    value: 'gsc',
  },
  {
    display: 'Houston, TX',
    value: 'hou',
  },
  {
    display: 'Indianapolis, IN',
    value: 'ind',
  },
  {
    display: 'Jacksonville, FL',
    value: 'jax',
  },
  {
    display: 'Kansas City, KS',
    value: 'kcy',
  },
  {
    display: 'New Orleans, LA',
    value: 'nol',
  },
  {
    display: 'Oklahoma City, OK',
    value: 'okc',
  },
  {
    display: 'Pittsburgh, PA',
    value: 'pit',
  },
  {
    display: 'Raleigh, NC',
    value: 'ral',
  },
  {
    display: 'Richmond, VA',
    value: 'rva',
  },
  {
    display: 'St. Louis, MO',
    value: 'stl',
  },
  {
    display: 'San Antonio, TX',
    value: 'san',
  },
  {
    display: 'Tysons, VA',
    value: 'nva',
  },
  {
    display: 'Virginia Beach, VA',
    value: 'vab',
  },
];


// WEBPACK FOOTER //
// ./src/constants/covidlocations.jsx